import axios, { Method } from 'axios';
import { useState, useEffect } from 'react';

const useAxios = (url: string, method: Method = 'GET') => {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    setIsLoading(true);
    setError(false);

    axios
      .request({
        url,
        method,
      })
      .then((response) => {
        if (isMounted) {
          setData(response?.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err);
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [url, method]);

  return { data, isLoading, error };
};

export default useAxios;
